import cn from "classnames"

import { Badge } from "@/atoms"
import { capitalizeFirstLetter } from "@/helpers/string.helpers"
import { useTranslation } from "@/hooks/useTranslation"
import { HddNo, HddOutlined } from "@/icons"
import { CardSectionTemplate } from "@/pages/TriagePage/components/pages/AdrManagementPage/components/templates/CardSectionTemplate"
import { PopoverEnvironmentCard } from "./PopoverEnvironmentCard"

import styles from "./EnvironmentCard.module.scss"

import type { EnvironmentCardProps } from "./EnvironmentCard.types"

export const EnvironmentCard = (props: EnvironmentCardProps) => {
  const { name, applications, detectedIncidentsCount, size = "default" } = props
  const { t } = useTranslation("translation", {
    keyPrefix: "triage.adr.management"
  })
  const isSuccess = !detectedIncidentsCount
  const appCount = applications?.length

  if (size !== "default") {
    const xs = size === "xs"
    const sm = size === "sm"
    const hasIncidents = !isSuccess
    const noMonitoring = !props.isMonitoringAdr
    const { br, bl } = props

    return (
      <PopoverEnvironmentCard {...props}>
        <div
          data-br={br}
          data-bl={bl}
          className={cn(styles.box, {
            [styles.boxSm]: sm,
            [styles.boxXs]: xs,
            [styles.boxSuccess]: isSuccess && props.isMonitoringAdr,
            [styles.boxIncident]: hasIncidents,
            [styles.boxIncidentXs]: hasIncidents && xs,
            [styles.noMonitoring]: noMonitoring,
            [styles.noMonitoringIncident]: noMonitoring && hasIncidents
          })}
        />
      </PopoverEnvironmentCard>
    )
  }

  return (
    <PopoverEnvironmentCard {...props}>
      <CardSectionTemplate
        isSuccess={isSuccess}
        hasIncidents={!isSuccess}
        isMonitoring={props.isMonitoringAdr}
        classes={{ container: styles.container }}
        extra={
          <span
            className={cn(styles.text, styles.textSecondary, styles.subtitle)}
          >
            {t("app", { count: appCount })}
          </span>
        }
      >
        <span className={cn(styles.text, styles.textOverflow)}>
          {capitalizeFirstLetter(name)}
        </span>
        {props.isMonitoringAdr && (
          <>
            {isSuccess && <HddOutlined className={styles.textSecondary} />}
            {!isSuccess && <Badge count={detectedIncidentsCount} />}
          </>
        )}
        {!props.isMonitoringAdr && <HddNo className={styles.textSecondary} />}
      </CardSectionTemplate>
    </PopoverEnvironmentCard>
  )
}
